import { Class } from '@mitsubishi/shared/data-access';

export const CHILLER_FREE_ST_CLASS_NAME = 'chiller-free-st-class';
export const CHILLER_FREE_ST_CLASS = {
  id: -1,
  column: 1,
  name: CHILLER_FREE_ST_CLASS_NAME,
  descriptionId: 451845,
  description: '',
  hasPerformance: false,
  hasR32Filter: false,
  hasWarranties: false,
  certificationIds: [],
  productTypes: [],
  customClass: 'chiller-free-st-class',
} as Class;

export const EVAP_INLET_TYPES = [
  { id: 'EVA_INLET_TEMP', resourceId: 456946 },
  { id: 'EVA_INLET_FLOW', resourceId: 456947 },
] as const;

export const COND_OUTLET_TYPES = [
  { id: 'COND_OUTLET_TEMP', resourceId: 456946 },
  { id: 'COND_OUTLET_FLOW', resourceId: 456947 },
] as const;

export const CUSTOM_CONDITION_KEY = 'custom';

export const CUSTOM_CONDITION = {
  id: null,
  desc: 'Custom',
  descKey: CUSTOM_CONDITION_KEY,
  resourceId: 456948,
};

export const STANDARD_CONDITION_RESOURCE_MAP: Record<string, number> = {
  ahri550590: 456949,
  ahri551591: 456950,
  gbt184301_comfort: 456951,
  gbt184301_process: 456952,
  gbt184301_idc: 456953,
};
